import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

// Docs
// https://docs.sentry.io/platforms/javascript/guides/react/

Sentry.init({
  dsn: 'https://a2489b1be204f48224e47addb643ce77@o4509334222733312.ingest.de.sentry.io/4509349189648464',
  environment: import.meta.env.MODE,
  release: APP_VERSION,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(), // Performance monitoring (traces user navigation)
    Sentry.replayIntegration(), // Session replay (captures user session for errors)
    Sentry.captureConsoleIntegration(), // Captures console.error/warn/info
    Sentry.httpClientIntegration(), // Captures fetch/XHR errors
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }), // Use react-router v6
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0, // Adjust for production (e.g., 0.2 for 20% of sessions)
  replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 0.01 : 0.1, // Adjust for production (e.g., 0.01 for 1% of sessions)
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
})
